import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { teamName, tip } = location.state || {};

  return (
    <div className="success-page">
      <motion.div
        className="success-card"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', duration: 0.6 }}
      >
        <motion.div
          className="success-icon"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
        >
          🎉
        </motion.div>

        <h1 className="success-title">Пријава успешна!</h1>

        <p className="success-text">
          {teamName ? (
            <>
              Тим <strong>„{teamName}"</strong> ({tip}) је успешно пријављен
              за учешће на ХакатонКМ такмичењу!
            </>
          ) : (
            <>Ваш тим је успешно пријављен за учешће на ХакатонКМ такмичењу!</>
          )}
          <br /><br />
          Организациони тим ће прегледати вашу пријаву и послати потврду на
          емаил адресу капитена тима. Хвала на пријави!
        </p>

        <button className="success-btn" onClick={() => navigate('/')}>
          ← Назад на почетну
        </button>
      </motion.div>
    </div>
  );
};

export default Success;
